/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import AddComment16 from '@carbon/icons-react/es/add-comment/16';
import CheckboxChecked16 from '@carbon/icons-react/es/checkbox--checked/16';
import React, { FC, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CommentService } from 'components/organisms/document/services/comment';
import { TaskService } from 'components/organisms/document/services/task';
import {
  DocumentTabsFreeMode,
  selectDocumentTabsFreeMode,
  toggleDocumentTabsFreeMode,
} from 'data/layout';
import { useToggleFreeMode } from 'hooks/use-toggle-free-mode';
import { useTranslation } from 'hooks/use-translation';
import {
  PopupType,
  setBalloonToolbarDetails,
  useDocuments,
} from '../../document-store';
import styles from './tool-component.module.css';

export const BalloonCommentHandler: FC = () => {
  const dispatch = useDispatch();
  const documentsTabsActive = useSelector(selectDocumentTabsFreeMode);
  const onToggle = (value: boolean) => {
    dispatch(toggleDocumentTabsFreeMode(value));
  };
  const documentTabsFreeHandler = useToggleFreeMode({
    active: documentsTabsActive,
    localStorageKey: DocumentTabsFreeMode,
    onToggle,
  });
  const handleClick = () => {
    CommentService.showCommentForm();
    documentTabsFreeHandler.exit();
  };
  const addComment = useTranslation('toolbar.add_comment');

  return (
    <div
      onClick={handleClick}
      onMouseDown={(e) => e.preventDefault()}
      className={styles.action}
    >
      <AddComment16 />
      {addComment}
    </div>
  );
};

export const BalloonTaskHandler: FC = () => {
  const [, dispatch] = useDocuments();
  const addTask = useTranslation('toolbar.add_task');
  const toolbarRef = useRef<HTMLDivElement>(null);
  const handleClick = () => {
    const positions = toolbarRef?.current?.getBoundingClientRect();

    TaskService.showTaskForm({ top: positions?.top, left: positions?.left });

    setBalloonToolbarDetails(dispatch, {
      type: PopupType.TaskForm,
      position: {
        x: positions ? positions.x + 119 : 0,
        y: positions ? positions?.y + 44 : 0,
      },
    });
  };

  return (
    <div
      onClick={handleClick}
      ref={toolbarRef}
      onMouseDown={(e) => e.preventDefault()}
      className={styles.action}
    >
      <CheckboxChecked16 />
      {addTask}
    </div>
  );
};
